module.exports = __webpack_public_path__ + "img/brush-yellow.adb2cefe.png";